import { CustomAddMediumChip } from './../../../../../components/CustomAddMediumChip';
import IngredientsApp from '../Functionality/IngredientsApp';
import { getUnitTransByName} from '../../Ingredients/Model/Models';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */

const Ingredients = ({
    selectedIngredients,
    setSelectedIngredients,
    disabled,
    ingredients,
    handleIngredientDelete,
    emptyFields,
    permissionUpdate,
    t,
}) => {
    const { allIngredients } = IngredientsApp(setSelectedIngredients, ingredients);

    return (
        <div className='col-12 mb-3'>
            <CustomAddMediumChip
                autocompleteId={'slt_i_ingredients'}
                buttonId='btn_add_ingredient'
                disabled={disabled}
                label='select_ingredient'
                transUnit='add_quantity'
                data={allIngredients.map((i) => ({
                    id: i.id,
                    label: i.name,
                    subtitle: t(getUnitTransByName(i?.measurementUnit?.name)),
                }))}
                selectedList={selectedIngredients}
                setSelectedList={setSelectedIngredients}
                required={true}
                onDeleteItem={permissionUpdate ? handleIngredientDelete: undefined}
                emptyFields={emptyFields}
            />
        </div>
    );
};

export default Ingredients;
